import React from 'react';
import propTypes from './propTypes';

const MachinesOverallState = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="16.5" r="1.5" fill="currentColor" />
    <circle cx="12.5" cy="16.5" r="1.5" fill="currentColor" />
    <path d="M9.9792 2H4C2.34315 2 1 3.34315 1 5V22C1 22.5523 1.44772 23 2 23H4C4.55228 23 5 22.5523 5 22V21H13V22C13 22.5523 13.4477 23 14 23H16C16.5523 23 17 22.5523 17 22V16.4418C16.672 16.4802 16.3383 16.5 16 16.5C15.6617 16.5 15.328 16.4802 15 16.4418V18C15 18.5523 14.5523 19 14 19H4C3.44772 19 3 18.5523 3 18V14H9.9792C9.39315 13.4119 8.8927 12.7385 8.4981 12H3V10.6667L5 8H7.5C7.5 7.31112 7.58195 6.64138 7.73663 6H4.5C4.18524 6 3.88885 6.14819 3.7 6.4L3 7.33333V5C3 4.44772 3.44772 4 4 4H8.4981C8.8927 3.26149 9.39315 2.58807 9.9792 2Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16 15C19.866 15 23 11.866 23 8C23 4.13401 19.866 1 16 1C12.134 1 9 4.13401 9 8C9 11.866 12.134 15 16 15ZM16 13C18.7614 13 21 10.7614 21 8C21 5.23858 18.7614 3 16 3C13.2386 3 11 5.23858 11 8C11 10.7614 13.2386 13 16 13Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.97 8.17L18.1 5L19.5 6.41L14.97 11L12.5 8.5L13.9 7.09L14.97 8.17Z" fill="currentColor" />
  </svg>
);

MachinesOverallState.propTypes = propTypes;

export default MachinesOverallState;
